import { ColumnConfig } from '@/components/table/Table';
import { UserApi } from '../../Users/models';
import { extractDate } from '@/utils';
import { RequestStatus, RequestStatusLabels } from '../enums';

export const requestsColumns: ColumnConfig[] = [
  {
    label: 'Administrador',
    field: 'admin',
    render: (admin?: Pick<UserApi, 'id' | 'fullName'> | null) =>
      admin?.fullName || '______',
  },
  {
    label: 'Usuario',
    field: 'user',
    render: (user?: Pick<UserApi, 'id' | 'fullName'> | null) =>
      user?.fullName || '______',
  },
  {
    label: 'Tipo',
    field: 'assetType',
    render: (assetType: { name: string } | null, rowData: { type: string; note: string }) => {
      if (rowData.type === 'OTHER' && rowData.note) {
        const match = rowData.note.match(/Tipo solicitado: (.+?)(?:\.|$)/);
        return match ? match[1] : 'Otro';
      }
      return assetType?.name || '______';
    },
  },
  {
    label: 'Estado',
    field: 'status',
    render: (status: string) =>
      RequestStatusLabels[status as RequestStatus] ?? status,
  },
  {
    label: 'Fecha de la solicitud',
    field: 'createdAt',
    render: (date: string) => extractDate(date),
    sortable: true,
  },
  {
    label: 'Fecha necesaria',
    field: 'neededAt',
    render: (date: string) => extractDate(date),
    sortable: true,
  },
  {
    label: 'Manejado por',
    field: 'handledBy',
    render: (handledBy?: Pick<UserApi, 'id' | 'fullName'> | null) =>
      handledBy?.fullName || '______',
  },
  {
    label: 'Nota',
    field: 'note',
    render: (note: string) => {
      if (!note) return '______';
      return (
        note.replace(/Tipo solicitado: .+?(?:\.|$)/, '').trim() || '______'
      );
    },
  },
  {
    label: 'Nota de respuesta',
    field: 'responseNote',
    render: (responseNote: string) => responseNote || '______',
  },
];
